import React from 'react';

interface DashboardPaginationProps {
    paginationInfo: {
        page: number;
        limit: number;
        total: number;
        pages: number;
        has_next: boolean;
        has_prev: boolean;
    };
    onPageChange: (page: number) => void;
}

const DashboardPagination: React.FC<DashboardPaginationProps> = ({
    paginationInfo,
    onPageChange
}) => {
    if (!paginationInfo || paginationInfo.pages <= 1) return null;

    return (
        <div className="pagination">
            <button
                className="pagination-btn"
                disabled={!paginationInfo.has_prev}
                onClick={() => onPageChange(paginationInfo.page - 1)}
            >
                ← Prev
            </button>
            <span className="pagination-info">
                Page {paginationInfo.page} of {paginationInfo.pages} ({paginationInfo.total} items)
            </span>
            <button
                className="pagination-btn"
                disabled={!paginationInfo.has_next}
                onClick={() => onPageChange(paginationInfo.page + 1)}
            >
                Next →
            </button>
        </div>
    );
};

export default DashboardPagination;
